<vb-ui-toggle-content-display [minItems]="4" [totalItems]="supplementalContents.length">
	<div layout="row" *ngFor="let content of supplementalContents" #vbUiToggleItem>
		<span [hidden]="!playbackConfig?.disableFileDownloads" class="glyphicons circle_exclamation_mark padding-right-10" [tooltip]="'Media_Videos_Settings_Files_DesktopOnly' | translate" triggers="hover" placement="right">
		</span>
		<a [ngClass]="styles.item" [href]="content.downloadUrl" download [attr.disabled]="(!content.downloadUrl || playbackConfig?.disableFileDownloads) || null" [attr.aria-label]="content.title">
			<ng-container *ngIf="content.downloadUrl; else loading">
				<span class="glyphicons" [ngClass]="[ styles.fileIcon, getFileExtensionClass(content.extension) ]"></span>
			</ng-container>
			<ng-template #loading>
				<vb-loading-spinner></vb-loading-spinner>
			</ng-template>
			<span [ngClass]="styles.fileName">{{ content.title }}</span>
		</a>
	</div>
</vb-ui-toggle-content-display>
